import dayjs from 'dayjs';
import humps from 'humps';

import constants from '@/app/dashboards/constants';

export function filterAndSortUsers(users) {
  return (
    users
      ?.filter?.((user) => user.status === constants.USER_STATUS.ACTIVE)
      ?.sort?.((left, right) => {
        const leftUser = humps.camelizeKeys(left);
        const rightUser = humps.camelizeKeys(right);
        let compareOwner = 0;
        if (leftUser?.userRole === constants.ROLES.OWNER.value) {
          compareOwner = -1;
        } else if (rightUser?.userRole === constants.ROLES.OWNER.value) {
          compareOwner = 1;
        }
        const compareFirstName = leftUser?.firstName?.localeCompare(rightUser?.firstName);
        const compareLastName = leftUser?.lastName?.localeCompare(rightUser?.lastName);
        return compareOwner || compareFirstName || compareLastName;
      }) || []
  );
}

export function getAutoExportTimes() {
  return Array.from({ length: 24 }, (_, i) => {
    const time = dayjs().hour(i).minute(0).second(0);
    return {
      label: time.format('h a'),
      value: time.format('HH:mm:ss'),
    };
  });
}

export function getAutoExportTimeInAmPm(value) {
  const times = getAutoExportTimes();
  const timeObject = times.find((time) => time.value === value);
  return timeObject?.label;
}

export function extractAutoExportMixpanelProperties(autoExport) {
  const timeOfDay = autoExport?.converted_time_of_day ?? autoExport?.time_of_day;
  const scheduleTime = getAutoExportTimeInAmPm(timeOfDay);

  return {
    dashboardId: autoExport?.dashboard?.id,
    dashboardName: autoExport?.dashboard?.name,
    dayOfWeek: autoExport?.day_of_week,
    emailName: autoExport?.name,
    formatList: autoExport?.format_list,
    frequency: autoExport?.frequency,
    recipientUserIds: autoExport?.recipient_user_ids,
    scheduleTime,
    userCount: autoExport?.recipient_user_ids?.length,
  };
}

export function buildShareableLinkFilters({ reportingPeriod, comparisonPeriod }) {
  const defaultFilters = {
    reporting_period_mode: reportingPeriod.preset,
    context_period_mode: comparisonPeriod.preset,
  };
  if (reportingPeriod.preset === 'CUSTOM') {
    defaultFilters.start_date = dayjs(reportingPeriod.range.start).format('YYYY-MM-DD');
    defaultFilters.end_date = dayjs(reportingPeriod.range.end).format('YYYY-MM-DD');
  }
  if (comparisonPeriod.preset === 'CUSTOM') {
    defaultFilters.context_start_date = dayjs(comparisonPeriod.range.start).format('YYYY-MM-DD');
    defaultFilters.context_end_date = dayjs(comparisonPeriod.range.end).format('YYYY-MM-DD');
  }
  return new URLSearchParams(defaultFilters).toString();
}

export function getShareableLinkAvailability(link) {
  if (!link.enabled) {
    return '<span class="dash-text-subtle">Deactivated</span>';
  }
  if (dayjs(link.validUntil).isBefore(new Date())) {
    return '<span class="dash-text-subtle">Expired</span>';
  }
  return `Expires ${dayjs(link.validUntil).fromNow()}`;
}
